import React from 'react';

import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';

import Tags from 'components/shared/Tags/Tags';
import { permissions as permissionsState } from 'components/state';

// The write path requires both permissions (api/tags/update_tag_link.js), so without this gate a
// user holding only payments.read gets editable controls whose every save is rejected.
const TRANSACTION_TAG_WRITE_PERMISSIONS = ['tags.update', 'payments.read'];

const TransactionTagsCell = ({ value, data, readOnly = false, query }) => {
  const permissions = useRecoilValue(permissionsState);
  const canEdit = pm(permissions, TRANSACTION_TAG_WRITE_PERMISSIONS);

  return (
    <Tags
      value={value}
      data={data}
      kind="transaction"
      refTable="transaction"
      readOnly={readOnly || !canEdit}
      query={query}
    />
  );
};

export default TransactionTagsCell;
